import * as coreEntities from 'core/store/index';
import { CLIENT } from 'core/variables/constant';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useSystemSettings from './useSystemSettings';

export function useOrganization() {
  const client = useSelector((state) => coreEntities.organization.selectors.getClient(state));
  const tenantData = useSelector((state) => coreEntities.organization.selectors.getTenant(state));
  // const featureFlags = useSelector((state) => coreEntities.organization.selectors.getFeatureFlags(state));
  const canCreateGroup = useSelector((state) => coreEntities.organization.selectors.getCanCreateGroup(state));
  const canCreateCourse = useSelector((state) => coreEntities.organization.selectors.getCanCreateCourse(state));

  const { enableThirdPartyIntegrations } = useSystemSettings();

  const [canChangeAvatar, setCanChangeAvatar] = useState(true);
  const [hasSupport, setHasSupport] = useState(true);
  const [showAccountTab, setShowAccountTab] = useState(true);
  const [showDisregardedPrograms, setShowDisregardedPrograms] = useState(true);
  const [showKidsMode, setShowKidsMode] = useState(CLIENT.SANTILLANA_PILOTO);
  const [canEditProfileInfo, setCanEditProfileInfo] = useState(true);
  const [canEditCourse, setCanEditCourse] = useState(true);
  const [logoutRedirect, setLogoutRedirect] = useState(client === CLIENT.EDELVIVES || client === CLIENT.SANTILLANA_ALFA);
  const [hideLibrary, setHideLibrary] = useState(false);
  const [hideTeacher, setHideTeacher] = useState(false);
  const [hideEducationLevelGroup, setHideEducationLevelGroup] = useState(false);
  const [showSelectTypeLesson, setShowSelectTypeLesson] = useState(false);
  const [showAITemplate, setShowAITemplate] = useState(false);
  const [showImmersiveReaderFlag, setShowImmersiveReaderFlag] = useState(false);
  const [allowMoveCalendarSessions, setAllowMoveCalendarSessions] = useState(false);
  const [showPersonalizeAvatar, setShowPersonalizeAvatar] = useState(false);
  const [isGamified, setIsGamified] = useState(false);
  const [newProgramInterface, setNewProgramInterface] = useState(client === CLIENT.TANGERINE);
  const [enableTeacherCanCreateSection, setEnableTeacherCanCreateSection] = useState(true);

  useEffect(() => {
    if (client) {
      setShowKidsMode(client === CLIENT.SANTILLANA_PILOTO);
      setShowSelectTypeLesson(client === CLIENT.TANGERINE);
      setShowAITemplate(client === CLIENT.TANGERINE || client === CLIENT.SANTILLANA_DEMO);
      setShowImmersiveReaderFlag(client === CLIENT.TANGERINE || client === CLIENT.GOTITBYME);
      setShowPersonalizeAvatar(client === CLIENT.TANGERINE || client === CLIENT.MASTER_DEMO || client === CLIENT.MULTITUDE);
      setIsGamified(client === CLIENT.TANGERINE || client === CLIENT.MASTER_DEMO || client === CLIENT.MULTITUDE || client === CLIENT.MASTER);
      setEnableTeacherCanCreateSection(client !== CLIENT.SUMUM_CAMPUS);
      setNewProgramInterface(client === CLIENT.TANGERINE);
    }
  }, [client]);

  useEffect(() => {
    if (enableThirdPartyIntegrations) {
      setCanChangeAvatar(false);
      setHasSupport(false);
      setShowAccountTab(false);
      setShowDisregardedPrograms(false);
      setCanEditProfileInfo(false);
      setCanEditCourse(false);
      setLogoutRedirect(true);
      setHideLibrary(true);
      setHideTeacher(true);
      setHideEducationLevelGroup(true);
      setNewProgramInterface(true);
    }
  }, [enableThirdPartyIntegrations]);

  return {
    client,
    tenantConfig: {
      ...tenantData,
      hideTeacher,
      showLogout: true,
      canChangeAvatar,
      hasSupport,
      showAccountTab,
      canCreateGroup,
      canCreateCourse,
      showDisregardedPrograms,
      showKidsMode,
      hideLibrary,
      hideEducationLevelGroup,
      canEditProfileInfo,
      canEditCourse,
      logoutRedirect,
      newProgramInterface,
      showSelectTypeLesson,
      showAITemplate,
      showImmersiveReaderFlag,
      allowMoveCalendarSessions,
      showPersonalizeAvatar,
      isGamified,
      enableTeacherCanCreateSection,
    },
  };
}
